export enum FeedSkeletonType {
	Partner = 'partner',
	Post = 'post',
	Title = 'title'
}
